import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IInvoiceState }        from 'Redux/Slices/Invoice/InvoiceSlice';
import { Invoice }              from 'Domain/Models';
import { PayloadActionList }    from 'Utils';
import { removeActionTypes }    from 'Utils/ReducerUtility';


export const findInvoicesRequest = (state: Draft<IInvoiceState>, { type }: PayloadActionList) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findInvoicesSuccess = (state: Draft<IInvoiceState>, { type, payload }: PayloadAction<{
  invoices: Record<string, Invoice>,
  maxCount: number,
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = payload.invoices;
  state.maxCount = payload.maxCount || state.maxCount;

};

export const findInvoicesFailure = (state: Draft<IInvoiceState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
